module.exports = __webpack_public_path__ + "static/media/logout-icon.512f8af4.svg";